var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLicenseCalenderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1586_4778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 0.625C5 0.45924 4.93415 0.300269 4.81694 0.183058C4.69973 0.065848 4.54076 0 4.375 0C4.20924 0 4.05027 0.065848 3.93306 0.183058C3.81585 0.300269 3.75 0.45924 3.75 0.625V1.25H2.5C1.83696 1.25 1.20107 1.51339 0.732233 1.98223C0.263392 2.45107 0 3.08696 0 3.75L0 5H20V3.75C20 3.08696 19.7366 2.45107 19.2678 1.98223C18.7989 1.51339 18.163 1.25 17.5 1.25H16.25V0.625C16.25 0.45924 16.1842 0.300269 16.0669 0.183058C15.9497 0.065848 15.7908 0 15.625 0C15.4592 0 15.3003 0.065848 15.1831 0.183058C15.0658 0.300269 15 0.45924 15 0.625V1.25H5V0.625ZM11.7525 12.8075C12.5338 12.8075 13.2325 12.2025 13.2325 11.3325C13.2325 10.2925 12.5737 9.795 11.7825 9.795C11.05 9.795 10.3225 10.2787 10.3225 11.3075C10.3225 12.3287 11.0013 12.8075 11.7525 12.8075Z",
    fill: "#006AB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 17.5V6.25H0V17.5C0 18.163 0.263392 18.7989 0.732233 19.2678C1.20107 19.7366 1.83696 20 2.5 20H17.5C18.163 20 18.7989 19.7366 19.2678 19.2678C19.7366 18.7989 20 18.163 20 17.5ZM11.67 15.9875C10.2825 15.9875 9.6 15.0288 9.54125 14.2288H10.395C10.4487 14.6913 10.8787 15.2537 11.7087 15.2537C12.7637 15.2537 13.335 14.1937 13.34 12.5487H13.3063C13.115 13.0662 12.51 13.5363 11.5775 13.5363C10.5125 13.5363 9.4825 12.7737 9.4825 11.3238C9.4825 9.9025 10.5713 9.0625 11.7288 9.0625C13.1938 9.0625 14.17 9.98 14.17 12.3975C14.17 14.6538 13.2425 15.9862 11.67 15.9862V15.9875ZM8.0575 9.19375V15.8588H7.2125V10.0988H7.1975C6.835 10.2938 6.09375 10.7487 5.625 11.07V10.2C6.15172 9.83244 6.69976 9.49644 7.26625 9.19375H8.0575Z",
    fill: "#006AB3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1586_4778"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenseCalenderIcon);
export default __webpack_public_path__ + "static/media/licenseCalenderIcon.8c79f61763cbc779d3c8e583c695b23c.svg";
export { ForwardRef as ReactComponent };